"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useSuperLinkState = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var initialContext = {
  state: {
    safeDomains: [],
    LinkComponent: _router.Link
  }
};
var SuperLinkStateContext = (0, _react.createContext)(initialContext);

var SuperLinkProvider = function SuperLinkProvider(_a) {
  var children = _a.children,
      props = (0, _tslib.__rest)(_a, ["children"]);
  return _react["default"].createElement(SuperLinkStateContext.Provider, {
    value: {
      state: props
    }
  }, children);
};

var useSuperLinkState = function useSuperLinkState() {
  return (0, _react.useContext)(SuperLinkStateContext);
};

exports.useSuperLinkState = useSuperLinkState;
var _default = SuperLinkProvider;
exports["default"] = _default;